<template>
  <div class="row address-wrap">
    <!-- Name -->
    <div class="form-group col-md-12">
      <label for="inputlname" class="control-label">
        {{ $t('checkout.label.payer_type') }} <span class="color">*</span>
      </label>
      <div class="input-group">
        <label class="label" style="height: 17px">
          <span class="label-content label-xs-show label-sm-show label-md-show">
          </span>
        </label>
        <div
          id="16248890500339"
          role="radiogroup"
          tabindex="-1"
          class="bv-no-focus-ring"
        >
          <div class="custom-control custom-radio mt-1">
            <input
              id="option_1"
              type="radio"
              name="payer_type"
              autocomplete="off"
              class="custom-control-input"
              value="1"
              :checked="billingAddress.payer_type == 1"
              @change="handlePayerType(1)"
            />
            <label
              for="option_1"
              class="custom-control-label"
              style="height: 17px"
            >
              <span>Fizinis asmuo</span>
            </label>
          </div>
          <div class="custom-control custom-radio">
            <input
              id="option_2"
              type="radio"
              name="payer_type"
              autocomplete="off"
              class="custom-control-input"
              value="2"
              :checked="billingAddress.payer_type == 2"
              @change="handlePayerType(2)"
            />
            <label
              for="option_2"
              class="custom-control-label"
              style="height: 17px"
            >
              <span>Juridinis asmuo</span>
            </label>
          </div>
        </div>
      </div>
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.payer_type"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.payer_type') }}
      </div>
      <!-- Errors end's -->
    </div>
    <!-- Name -->
    <div class="form-group col-md-4">
      <label for="inputlname" class="control-label">
        {{ $t('checkout.label.name') }} <span class="color">*</span>
      </label>
      <input
        id="inputfname"
        v-model="billingAddress.firstname"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.firstname ? 'has-error' : 'has-success'
        "
        required
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.firstname"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.name') }}
      </div>
      <!-- Errors end's -->
    </div>
    <!-- Surname -->
    <div class="form-group col-md-4">
      <label for="inputlname" class="control-label">
        {{ $t('checkout.label.surname') }} <span class="color">*</span>
      </label>
      <input
        id="inputlname"
        v-model="billingAddress.lastname"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.lastname ? 'has-error' : 'has-success'
        "
        required
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.lastname"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.lastname') }}
      </div>
      <!-- Errors end's -->
    </div>
    <!-- Email -->
    <div class="form-group col-md-4">
      <label for="inputemail" class="control-label">
        {{ $t('checkout.label.email') }} <span class="color">*</span>
      </label>
      <input
        id="inputemail"
        v-model="billingAddress.email"
        type="email"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.email ? 'has-error' : 'has-success'
        "
        required
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.email"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.email') }}
      </div>
      <!-- Errors end's -->
    </div>

    <!-- Country -->
    <div class="form-group col-md-4">
      <label for="inputcountry" class="control-label">
        {{ $t('checkout.label.country') }}
      </label>
      <input
        id="inputcountry"
        v-model="billingAddress.country"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.country ? 'has-error' : 'has-success'
        "
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.country"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.country') }}
      </div>
      <!-- Errors end's -->
    </div>

    <!-- City -->
    <div class="form-group col-md-4">
      <label for="inputcity" class="control-label">
        {{ $t('checkout.label.city') }}
      </label>
      <input
        id="inputcity"
        v-model="billingAddress.city"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.city ? 'has-error' : 'has-success'
        "
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.city"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.city') }}
      </div>
      <!-- Errors end's -->
    </div>

    <!-- Zip code -->
    <div class="form-group col-md-2">
      <label for="inputzipcode" class="control-label">
        {{ $t('checkout.label.zip_code') }}
      </label>
      <input
        id="inputzipcode"
        v-model="billingAddress.zip"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="errorsShow && !billingAddress.zip ? 'has-error' : 'has-success'"
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.zip"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.zip_code') }}
      </div>
      <!-- Errors end's -->
    </div>

    <!-- Address -->
    <div class="form-group col-md-8">
      <label for="inputaddress" class="control-label">
        {{ $t('checkout.label.address') }}
      </label>
      <input
        id="inputaddress"
        v-model="billingAddress.address"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.address ? 'has-error' : 'has-success'
        "
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.address"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.address') }}
      </div>
      <!-- Errors end's -->
    </div>

    <!-- Company name -->
    <div v-if="billingAddress.payer_type == 2" class="form-group col-md-6">
      <label for="inputcompanyname" class="control-label">
        {{ $t('checkout.label.company') }}
      </label>
      <input
        id="inputcompanyname"
        v-model="billingAddress.company_name"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.company_name
            ? 'has-error'
            : 'has-success'
        "
        required
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.company_name"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.company') }}
      </div>
      <!-- Errors end's -->
    </div>
    <!-- Company code -->
    <div v-if="billingAddress.payer_type == 2" class="form-group col-md-6">
      <label for="inputcompanycode" class="control-label">
        {{ $t('checkout.label.company_code') }}
      </label>
      <input
        id="inputcompanycode"
        v-model="billingAddress.company_code"
        type="text"
        placeholder=""
        class="form-control form-checkout-control"
        :class="
          errorsShow && !billingAddress.company_code
            ? 'has-error'
            : 'has-success'
        "
        required
      />
      <!-- Errors -->
      <div
        v-if="errorsShow && !billingAddress.company_code"
        class="field-error field-error-adr"
      >
        {{ $t('checkout.error.company_code') }}
      </div>
      <!-- Errors end's -->
    </div>

    <div class="form-group col-md-12">
      <div class="field-fill-notice">
        <span class="color">*</span> {{ $t('checkout.note.fill_required') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Address',
  components: {},
  props: {
    countries: {
      type: [Array, Object],
      default: () => [],
    },
    user: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      errors: {},
      noErrors: false,
      errorsPaymentMethod: {},
      errorsBillingAddress: {},
      noErrorsBillingAddress: false,
    }
  },
  computed: {
    model() {
      return this.$store.getters['getData']
    },
    addressData() {
      return this.$store.getters['getAddressData']
    },
    errorsShow() {
      return this.$store.getters['order/getShowErrors']
    },
    billingAddress() {
      return this.$store.state.checkout.billingAddress
    },
    paymentsData() {
      return this.$store.getters['getPaymentsData']
    },
  },
  mounted() {
    // this.$store.dispatch('getCountries')
  },
  methods: {
    handlePayerType(type) {
      this.billingAddress.payer_type = type
    },
    setSompany(selectedOption) {
      if (selectedOption) {
        this.billingAddress.firstname = this.user.name
        this.billingAddress.lastname = this.user.surname
        this.billingAddress.company_name = selectedOption.name
        this.billingAddress.vat_no = selectedOption.vat_no
        this.billingAddress.zip = selectedOption.zip_code
        this.billingAddress.address = selectedOption.address
        this.billingAddress.email = selectedOption.email
        this.billingAddress.phone = selectedOption.phone

        if (selectedOption.hasOwnProperty('adr_city')) {
          this.billingAddress.city = selectedOption.adr_city
        }

        if (selectedOption.hasOwnProperty('country')) {
          this.model.country = selectedOption.country
          this.billingAddress.country_name = selectedOption.country.asciiname
          this.billingAddress.country_code = selectedOption.country.code
        }

        this.model.paymentMethod.type_id = ''
        this.model.paymentMethod.payment_method = ''
        this.model.paymentMethod.payment_fee = 0
        this.model.paymentMethod.sub_type_id = ''

        this.paymentsData.payment_sub_methods = {}
      }
    },
    removeCompany() {
      this.billingAddress.firstname = ''
      this.billingAddress.lastname = ''
      this.billingAddress.company_name = ''
      this.billingAddress.vat_no = ''
      this.billingAddress.zip = ''
      this.billingAddress.address = ''
      this.billingAddress.email = ''
      this.billingAddress.phone = ''
      this.billingAddress.city = ''
      this.model.country = ''
      this.model.country_code = ''
      this.model.country_name = ''

      this.model.paymentMethod.type_id = ''
      this.model.paymentMethod.payment_method = ''
      this.model.paymentMethod.payment_fee = 0
      this.model.paymentMethod.sub_type_id = ''

      this.paymentsData.payment_sub_methods = {}
    },
    setCountry(selectedOption) {
      if (selectedOption) {
        this.billingAddress.country_code = selectedOption.code
        this.billingAddress.country_name = selectedOption.asciiname

        this.paymentsData.payment_sub_methods = {}

        this.model.paymentMethod.type_id = ''
        this.model.paymentMethod.payment_method = ''
        this.model.paymentMethod.payment_fee = 0
        this.model.paymentMethod.sub_type_id = ''

        this.model.country = selectedOption
      }
    },
    removeCountry() {
      this.billingAddress.country_code = ''
      this.billingAddress.country_name = ''

      this.paymentsData.payment_sub_methods = {}

      this.model.paymentMethod.type_id = ''
      this.model.paymentMethod.payment_method = ''
      this.model.paymentMethod.payment_fee = 0
      this.model.paymentMethod.sub_type_id = ''

      this.model.country = ''
    },
    // gets a flag picture
    getFlag(flagName) {
      try {
        return require(`@main/images/flags/${flagName.toLowerCase()}.svg`)
      } catch (e) {
        return require('@main/images/flags/undefined.svg')
      }
    },
  },
}
</script>
